import React, { useState, useCallback, useMemo, } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import LocationAlertModal from '../../../components/LocationAlertModal/LocationAlertModal';

const ListaEmpresas = ({ setAll, companies, setSelectedMarker, handleMarkerClick }) => {

    const [showModal, setShowModal] = useState(false);
    const [companyName, setCompanyName] = useState("");

    const handleShowModal = (name) => {
        setCompanyName(name);
        setShowModal(true);
    };

    const textoLimitado = (texto = '', limite = 25) =>
        texto.length > limite ? texto.slice(0, limite) + '...' : texto;

    const renderCompany = useCallback((company) => (
        <Card
            border="light"
            key={company._id}
            className="mb-2 p-0 card-list-empresas"
            style={{
                cursor: 'pointer',
                background: 'linear-gradient(135deg, #2a2d30, #3a3d42)',
                borderRadius: '8px',
                transition: '0.3s ease-in-out',
            }}
            onMouseOver={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, #3c3f44, #4a4d52)'}
            onMouseOut={(e) => e.currentTarget.style.background = 'linear-gradient(135deg, #2a2d30, #3a3d42)'}
            onClick={() => {
                const lat = Number(company?.location?.lat) || 0;
                const lng = Number(company?.location?.lng) || 0;

                if (lat === 0 && lng === 0) {
                    handleShowModal(company?.name);
                    return;
                }

                handleMarkerClick({
                    lat,
                    lng,
                    c: company?.chart_p ?? 'P_0',
                    m: company?.chart_m ?? 'P_0',
                    pp: company?.pp ?? 0,
                    i: true,
                    _id: company._id,
                });
            }}
        >
            <Card.Body className="p-2">
                <Row>
                    <Col md={10}>
                        <h5 style={{ fontSize: 15, marginBottom: 5, color: "#f8f9fa" }}>
                            {textoLimitado(company?.name, 30)}
                        </h5>
                        <h6 style={{ fontSize: 13, color: "#e0e0e0", marginBottom: 0 }}>
                            Recebendo: <span style={{ color: "#ffcc70", fontWeight: 'bold' }}>{(Number(company?.pp) || 0) > 0 ? company.pp : (company?.chart_p ?? 'P_0')}</span><br />
                            Expedindo: <span style={{ color: "#ffcc70", fontWeight: 'bold' }}>{company?.chart_m ?? 'P_0'}</span>
                        </h6>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    ), [handleMarkerClick]);

    const companyList = useMemo(() => companies.map(renderCompany), [companies, renderCompany]);

    return (
        <div>
            <Button
                variant="secondary"
                className="mb-3 w-100"
                onClick={() => {
                    setSelectedMarker(null)
                    setAll(false)
                }}
            >
                Ver Todas
            </Button>
            {companyList}

            <LocationAlertModal
                companyName={companyName}
                show={showModal}
                handleClose={() => setShowModal(false)}
            />
        </div>
    );
};

export default ListaEmpresas;
